module.exports = __webpack_public_path__ + "img/组7@2x(2).8c36846d.png";